export default "__VITE_ASSET__0cd3c927__"